/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Review } from './Review';
import {
    ReviewFromJSON,
    ReviewFromJSONTyped,
    ReviewToJSON,
} from './Review';

/**
 * Representation of a Review List
 * @export
 * @interface ReviewList
 */
export interface ReviewList {
    /**
     * List of reviews
     * @type {Array<Review>}
     * @memberof ReviewList
     */
    reviews?: Array<Review>;
}

/**
 * Check if a given object implements the ReviewList interface.
 */
export function instanceOfReviewList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewListFromJSON(json: any): ReviewList {
    return ReviewListFromJSONTyped(json, false);
}

export function ReviewListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reviews': !exists(json, 'reviews') ? undefined : ((json['reviews'] as Array<any>).map(ReviewFromJSON)),
    };
}

export function ReviewListToJSON(value?: ReviewList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reviews': value.reviews === undefined ? undefined : ((value.reviews as Array<any>).map(ReviewToJSON)),
    };
}

